import { IParamsObject, IServerResponse } from "@/api/types";
import { AxiosResponse } from "axios";
import { axiosInstance } from "@/api/index";
import { API_AFFILIATES_BALANCE_URL } from "@/configs/global";
import { IHoldConversionData, IHoldHistoryData } from "@crm-ui/types";
import { IEmployeesBalance } from "@/api/types/affiliate-balance";

export async function getHoldHistoryBff(data: IParamsObject, isExport?: boolean): Promise<IServerResponse<IHoldHistoryData>> {
    const headers = isExport ? { 'Accept': "text/csv" } : {};
    return axiosInstance.request<IServerResponse<IHoldHistoryData>>({
        method: 'POST',
        url: `${API_AFFILIATES_BALANCE_URL}/employees/hold-history`,
        data,
        headers,
    })
        .then((response: AxiosResponse<IServerResponse<IHoldHistoryData>>) => response.data);
}

export async function getHoldConversionsBff(data: IParamsObject, isExport?: boolean): Promise<IServerResponse<IHoldConversionData>> {
    const headers = isExport ? { 'Accept': "text/csv" } : {};
    return axiosInstance.request<IServerResponse<IHoldConversionData>>({
        method: 'POST',
        url: `${API_AFFILIATES_BALANCE_URL}/employees/hold-conversions`,
        data,
        headers,
    })
        .then((response: AxiosResponse<IServerResponse<IHoldConversionData>>) => response.data);
}

export async function getEmployeesBalances(
    affiliateIds: number[],
): Promise<IEmployeesBalance[]> {
    return axiosInstance.request<IServerResponse<IEmployeesBalance[]>>({
        method: 'POST',
        url: `${API_AFFILIATES_BALANCE_URL}/employees/balances`,
        data: { affiliate_ids: affiliateIds },
    })
        .then((response: AxiosResponse<IServerResponse<IEmployeesBalance[]>>) => response.data.data);
}

